import { render, staticRenderFns } from "./searchIdName.vue?vue&type=template&id=618fedea&"
import script from "./searchIdName.vue?vue&type=script&lang=js&"
export * from "./searchIdName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports